import { Flex, Spin } from "antd"
import React, { type ReactNode, useEffect, useState } from "react"
import { Navigate } from "react-router-dom"

import { RoutesPaths } from "../../../constants/routes.ts"
import { useAppSelector } from "../../../hooks/use-app-selector.ts"
import { canSeeSignatureRequests } from "../helpers/signature-requests-access.ts"

const PERMISSIONS_WAIT_MS = 8000

export function SignatureRequestsGate({ children }: { children: ReactNode }) {
  const roleId = useAppSelector((state) => state.auth.userInfo?.role?.id)
  const pages = useAppSelector((state) => state.auth.permissions?.pages)
  const [waitExpired, setWaitExpired] = useState(false)

  useEffect(() => {
    if (roleId !== undefined) return
    const timer = setTimeout(() => setWaitExpired(true), PERMISSIONS_WAIT_MS)
    return () => clearTimeout(timer)
  }, [roleId])

  // The profile loads asynchronously on a cold boot: unknown waits, for a bounded time.
  if (roleId === undefined && !waitExpired) {
    return (
      <Flex
        align="center"
        justify="center"
        style={{ minHeight: "60vh" }}
        data-testid="signature-requests-gate-loading"
      >
        <Spin />
      </Flex>
    )
  }
  if (!canSeeSignatureRequests(pages))
    return <Navigate to={RoutesPaths.home} replace />
  return <>{children}</>
}
